import { Suspense, lazy, useMemo, useEffect, useState } from "react";
import { HashRouter, Routes, Route } from 'react-router-dom'
import { Context } from "./context";
import { auth, db } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth'
import { onSnapshot, doc, setDoc } from "firebase/firestore";
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';

const Home = lazy(() => import('./pages/Home').then(module => ({default:module.Home})))
const Main = lazy(() => import('./pages/Main').then(module => ({default:module.Main})))
const SignIn = lazy(() => import('./pages/SignIn').then(module => ({default:module.SignIn})))
const AdminLogin = lazy(() => import('./pages/AdminLogin').then(module => ({default:module.AdminLogin})))
const Admin = lazy(() => import('./pages/Admin').then(module => ({default:module.Admin})));

function App() {

  const [user,loading] = useAuthState(auth)
  const [guestUser,setGuestUser] = useState(JSON.parse(localStorage.getItem("guestUser")) || false)

  const memo = useMemo(() => ({
    user:user,
    loading:loading,
    guestUser:guestUser,
    setGuestUser:setGuestUser
  }),[user, loading, guestUser])

  useEffect(()=>{
    if(!user)return;

    onSnapshot(doc(db,"users",auth.currentUser.uid), snapshot => {
      if(!snapshot.exists()){
        addNewUser()
      }
    })
  },[user])
  
  const addNewUser = async() => {
    await setDoc(doc(db,"users",auth.currentUser.uid),{
      username:auth.currentUser.displayName,
      picture:auth.currentUser.photoURL,
      email:auth.currentUser.email,
      dialogues:[]
    })
  }

	return (
    <HashRouter>
      <Context.Provider value={memo}>
        <Suspense fallback={
          <div className="w-screen h-screen fixed top-0 left-0 flex items-center justify-center">
            <p className="text-white text-2xl font-bold">Loading...</p>
          </div>
        }>
            <Routes>

              <Route path="/home" element={<Home/>}/>
              <Route path="/" element={user || guestUser ? <Main/> : <SignIn/>}/>
              <Route path="/login" element={<AdminLogin/>}/>
              <Route path="/admin" element={<Admin/>}/>

            </Routes>
          <ToastContainer
            position="bottom-left"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </Suspense>
      </Context.Provider>
    </HashRouter>
	);
}

export default App;
